export const BeneficiaryRoutes = {
  INHERITANCE: 'inheritance'
};
